import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import { loadReport } from "../thunks/loadReportData";
import { CommReviewReportData } from "../types";

export const useCommReviewReportData = () => {
  const data = useSelector<StoreType, CommReviewReportData[] | undefined>(
    (s) => s.data.reports.exchbusiness.commReview.data
  );

  const dispatch = useDispatch();
  const dispatchLoadData = React.useCallback(() => dispatch(loadReport()), [
    dispatch,
  ]);

  return [data, dispatchLoadData] as [typeof data, typeof dispatchLoadData];
};
